import { ITeamLeadPodTypeJson } from '@scale/shared/types/expertManagement';
import { ITagJson } from '@scale/shared/types/tag';
import { useMutation } from 'react-query';
import apiFetch from 'react-scale/lib/api-fetch';

export const useCreatePodType = () => {
  return useMutation([`createPodType`], (podType: Partial<ITeamLeadPodTypeJson>) =>
    apiFetch(null, `internal/expert-management/podTypes`, {
      method: 'POST',
      body: {
        ...podType,
        associatedTags: (podType.associatedTags ?? []).map(tag => (tag as ITagJson)._id),
      },
    }),
  );
};
